export const STATE_NAME = "cart";
export const FORM_NAME = STATE_NAME;
export const STANDARD_SKU = "STD1";
export const FLEET_SKU = "FLT1";
export const UNLIMITED_SKU = "ULD1";
export const TEXAS_STATE_SALES_TAX_DECIMAL = 0.0825;
export const TEXAS_STATE_SALES_TAX_PERCENTAGE = 8.25;
export const TEXAS_STATE_TAXABLE_PORTION = 0.8;
export const TEXAS_STATE_ABBREVIATION = "TX";
